import styled, { css } from 'styled-components'
import { Container, Grid, Typography } from '@material-ui/core'
import { rem } from '../../utils/rem'
import { Button } from '../../components/button/button'
import { spacerCss } from '../../components/flexibleContent/fragments/spacer'

// Popular questions
export const StyledPopularQuestionTitle = styled(Typography)`
  width: auto;
  font-weight: 500;
  color: ${props => props.theme.palette.primary.dark};
  margin-bottom: ${props => props.theme.typography.pxToRem(30)};
  font-size: ${props => props.theme.typography.pxToRem(23)};
  text-align: left;

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: center;
    font-size: ${props => props.theme.typography.pxToRem(32)};
    margin-bottom: ${props => props.theme.typography.pxToRem(60)};

    &:focus {
      outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
    }
  }
`

export const StyledPopularQuestionsWrapper = styled(Grid)`
  position: relative;
  margin-top: ${props => props.theme.typography.pxToRem(30)};
  ${spacerCss('large', { bottom: false })};

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 0;
  }

  .MuiAccordionSummary-root {
    background-color: ${props => props.theme.palette.background.default} !important;
  }

  .MuiAccordionDetails-root {
    display: block;
  }
`

// Topic filter
export const StyledTopicFiltersWrapper = styled(Grid)`
  position: relative;
  margin-top: ${props => rem(45, props.theme)};
  padding: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => rem(122, props.theme)};
  }

  .MuiFormLabel-root {
    display: none;
  }

  .MuiFormControl-fullWidth {
    background-color: ${props => props.theme.palette.background.default};
  }
`

// FAQ section
export const StyledFAQSectionPayTitle = styled(Typography)<{ $loading?: boolean }>`
  font-weight: 500;
  color: ${props => props.theme.palette.primary.dark};
  font-size: ${props=> props.theme.typography.pxToRem(20)};
  margin-bottom: 0;
  transition: opacity 0.2s ease-in-out;
  opacity: ${props => props.$loading ? '0.3' : '1'};
  will-change: opacity;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(24)};
  }

  &:focus {
    outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
  }
`

export const StyledFAQSectionCta = styled(Button)`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  text-decoration: none;

  &:focus {
    outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
  }
`

export const StyledFAQSectionHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${props => props.theme.typography.pxToRem(25)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: ${props => props.theme.typography.pxToRem(63)};
  }
`

export const StyledFAQSectionWrapper = styled(Grid)< { $loading?: boolean }>`
  position: relative;
  margin-top: ${props => rem(20, props.theme)};
  padding: 0;
  transition: opacity 0.2s ease-in-out;
  opacity: ${props => props.$loading ? '0.3' : '1'};
  will-change: opacity;

  > section {
    width: 100%;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => rem(110, props.theme)};
    padding: 0;
  }

  .MuiAccordionSummary-root {
    background-color: ${props => props.theme.palette.background.default} !important;
  }

  .MuiAccordionDetails-root {
    display: block;
  }
`

// FAQ's content wrapper
export const StyledFAQContentWrapper = styled(Container)`
  position: relative;
  padding-bottom: ${props => rem(100, props.theme)};

  > section {
    width: 100%;
  }

  &::before {
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f2f2f2;
    position: absolute;
    z-index: -1;
    background: linear-gradient(to bottom, #f2f2f2 calc(100% - 500px), #ffffff 100%);
  }
`

// Contact CTA
export const StyledContactCtaWrapper = styled(Grid)`
  position: relative;
  width: 100%;
  margin-top: ${props => rem(72, props.theme)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => rem(200, props.theme)};
  }
    
  ${props => props.theme.breakpoints.up('lg')} {
    padding: 0 ${props => rem(25, props.theme)};
  }
`

// Popular guide articles
export const StyledPopularGuideArticlesTitle = styled(Typography)`
  display: inline-block;
  font-size: ${props => props.theme.typography.pxToRem(15)};
  font-weight: 500;
  color: ${props => props.theme.palette.primary.dark};
  margin: auto;
  margin-bottom: ${props => props.theme.typography.pxToRem(50)};
  text-align: center;
  max-width: 50%;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-bottom: ${props => props.theme.typography.pxToRem(84)};
  }
`

export const StyledPopularGuideArticlesWrapper = styled(Grid)`
  padding: 0;
  text-align: center;
  margin-top: ${props => props.theme.typography.pxToRem(60)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(100)};
  }
`

export const StyledFAQBannerWrapper = styled(Grid)`
  > div::after {
    background: #f2f2f2;
    opacity: 1;
    bottom: ${props => props.theme.typography.pxToRem(-1)};
  }
`

// FAQ Page container
export const StyledFAQPageIndexContainer = styled.div`
  div[class*="secondaryPageBanner__StyledWrapper"]::after {
    opacity: 1;
  }
`

export const StyledFAQHeader = styled(Grid)`
  margin-bottom: ${props => props.theme.typography.pxToRem(18)};
`

export const StyledFilteredItemsWrapper = styled(Grid)<{ $loading?: boolean }>`
  transition: opacity 0.2s ease-in-out;
  opacity: 1;
  will-change: opacity;

  ${props => props.$loading && css`
    opacity: 0.3;
  `}
`